import { numberFormatter, capitalizeWords, truncateToTwoDecimals } from '../../lib/util'
import CurrencySelector from './CurrencySelector'


export default function InvoiceSummary({ allRows, setShowOverallChargesModal, overAllCharges }) {
  const userLocale = navigator.language || navigator.userLanguage

  let summarySubtotal = allRows.reduce((total, item) => total + (item?.['item-unit-price'] * item?.['item-quantity']), 0)

  let totalTax = allRows.reduce((total, item) => {
    const percentageBasedValue = truncateToTwoDecimals(item["item-tax"] * item["item-quantity"] * item["item-unit-price"] / 100)
    const fixedBasedValue = truncateToTwoDecimals(item["item-tax"] * item["item-quantity"])
    const currentTax = item['item-tax-type'] === 'percentage' ? percentageBasedValue : fixedBasedValue
    return total + currentTax
  }, 0)

  // Calculate overall charges/discounts
  let totalCharges = overAllCharges?.reduce((total, charge) => {
    if (!charge.name || !charge.value) return total

    return total + (charge.isDiscount ? -charge.value : charge.value)
  }, 0) || 0

  const finalPrice =  summarySubtotal + totalTax + totalCharges
  
  return (
    <div className="w-80">
      <div className="bg-gray-50 rounded-xl p-6 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-gray-800">Invoice summary</h3>
          <CurrencySelector/>
        </div>
        
        <div className="space-y-3 pt-4 border-t border-gray-200">
          <div>
            <button type="button" onClick={()=> setShowOverallChargesModal(true)} 
              data-role="add-row" 
              className="flex items-center space-x-1 text-blue-600 hover:text-blue-700 font-medium transition-colors cursor-pointer">
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span>Add Charges / Discount</span>
            </button>
          </div>
          <div className="flex justify-between text-gray-600">
            <span>Subtotal</span>
            <span id='invoice-final-subtotal' className="font-mono">
              {numberFormatter(summarySubtotal, userLocale)}
            </span>
          </div>
          <div className="flex justify-between text-gray-600">
            <span>Tax</span>
            <span id='invoice-final-tax' className="font-mono">{numberFormatter(totalTax, userLocale)}</span>
          </div>
          {overAllCharges?.some(charge => charge.name && charge.value > 0) && (
            <div className="space-y-2">
              {overAllCharges.filter(charge => charge.name && charge.value > 0).map((charge, index) => {
                const displayAmount = charge.isDiscount ? -charge.value : charge.value

                return (
                  <div key={index} className="flex justify-between text-gray-600 text-sm">
                    <span className={charge.isDiscount ? 'text-green-600' : 'text-blue-600'}>
                      {capitalizeWords(charge.name)} {charge.isDiscount ? '(Discount)' : '(Charge)'}
                    </span>
                    <span className={`font-mono ${charge.isDiscount ? 'text-green-600' : 'text-blue-600'}`}>
                      {numberFormatter(displayAmount, userLocale)}
                    </span>
                  </div>
                )
              })}
            </div>
          )}
          <div className="flex justify-between text-lg font-semibold text-gray-900 pt-3 border-t border-gray-300">
            <span>Total</span>
            <span id='invoice-final-price' className="font-mono">{numberFormatter(finalPrice, userLocale)}</span>
          </div>
        </div>
      </div>
    </div>
  )
}